import { Injectable } from '@angular/core';
import { ContextService } from '@core/services/core/context.service';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { LogService } from '../core/log.service';
import { UiHelperService } from '../core/ui-helper.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsHelper {
  constructor(
    public ctx: ContextService,
    private settings: OpenNativeSettings,
    private ui: UiHelperService,
    private log: LogService
  ) {}

  openAppSettingsModal() {
    this.openAppSettingsModalWithCustomMessage(
      'PERMISSIONS.TITLE',
      'PERMISSIONS.MESSAGE'
    );
  }

  openAppSettingsModalWithCustomMessage(
    title: string,
    message: string,
    onReject?: () => void
  ) {
    if (!this.ctx.isApp) {
      this.ui.presentDialogOneButton(
        title,
        message,
        onReject,
      );
    } else {
      this.ui.presentDialog(
        title,
        message,
        () => {
          this.settings
            .open('application_details')
            .catch(e =>
              this.log.i(this, 'Error opening application settings', e)
            );
        },
        onReject,
        'CONFIGURATION',
        null
      );
    }
  }
}
